import { enumStatus } from "./options";
import { checkFilterAndWarn } from "./funciones";

// Reducers puros para la lista plana de casos que alimenta el Home (Services.jsx).
// Se aplican sobre las notificaciones del socket de actualización de casos.

export const applyCaseList = (_list, cases) => (Array.isArray(cases) ? cases : []);

export const applyUpsert = (list, { _id, case: newCase } = {}) => {
  if (!_id || !newCase) return list;
  const exists = list.some((c) => c?._id === _id);
  if (!exists) return [newCase, ...list];
  return list.map((c) => (c?._id === _id ? newCase : c));
};

export const applyCaseUpdate = (list, { _id, changed } = {}) => {
  if (!_id || !changed) return list;
  if (!list.some((c) => c?._id === _id)) return list;
  return list.map((c) => (c?._id === _id ? { ...c, ...changed } : c));
};

export const applyServiceUpdate = (list, { _id, serviceId, changed } = {}) => {
  if (!_id || !serviceId || !changed) return list;
  if (!list.some((c) => c?._id === _id)) return list;

  return list.map((c) => {
    if (c?._id !== _id) return c;

    const services = c?.services || [];
    const current = services.find((s) => s?._id === serviceId);
    const updatedServices = current
      ? services.map((s) => (s?._id === serviceId ? { ...s, ...changed } : s))
      : [...services, { _id: serviceId, ...changed }];

    const isLastService = !current || c?.lastService?._id === serviceId;
    const lastService = isLastService
      ? { ...(current ? c?.lastService : {}), _id: serviceId, ...changed }
      : c?.lastService;

    return { ...c, services: updatedServices, lastService };
  });
};

export const applyRemove = (list, { _id } = {}) => {
  if (!_id) return list;
  if (!list.some((c) => c?._id === _id)) return list;
  return list.filter((c) => c?._id !== _id);
};

const groupedStatuses = [
  "INITIATED",
  "AV_ASSIGNED",
  "AV_ON_ROAD",
  "AV_IN_ORIGIN",
  "SEARCHING_TOW",
  "TOW_ASSIGNED",
  "PENDING_LOAD",
  "TOW_IN_ORIGIN",
  "TOW_ON_ROAD",
  "CUSTOMER_ON_ROAD",
  "SCHEDULED",
  "FINISHED",
  "FAILED",
  "CANCELED",
  "FOLLOW_UP",
  "LOCKSMITH_ACTIVE",
];

export const groupCasesByStatus = (list = []) =>
  groupedStatuses.reduce((acc, key) => {
    acc[key] = checkFilterAndWarn(list, enumStatus[key]);
    return acc;
  }, {});
